import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import InputVirtual from 'components/InputVirtual'
import axios from 'axios';
import {BASE_URL_APIv5} from "constants/ActionTypes";

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const token = localStorage.getItem('apiKey')
const config = {
    headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`
    }
}

const rolename = localStorage.getItem('rolename')

const initialState = {
    fullname: '',
    username: '',
    password: '',
    email: '',
    locked: false,
    company: localStorage.getItem('companyId'),
    role_name: '',
}

const styles = theme => ({
    flex: {
        flex: 1,
    },
    appBar: {
        position: 'relative',
    },
})

class DialogUser extends React.Component {
    constructor(props) {
        super(props);
    }

    state = initialState

    getInputCompany = ({id}) => {
        // console.log(id)
        this.setState({company: id})
    }

    getInputRoleName = ({role_name}) => {
        // console.log(role_name)
        this.setState({role_name})
    }

    handleAddUser = async data => {
        let obj = JSON.stringify(data)
        const url = `${BASE_URL_APIv5}/user/new`
        const result = await axios.post(url, obj, config).then(res => res).catch(error => error.response)
        return result
    }

    handleSave = async param => {
        const {fullname, username, password, email, company, role_name} = this.state
        const obj = {
            fullname, 
            username, 
            password, 
            email, 
            company: parseInt(company), 
            role_name,
            locked: false
        }
        // console.log(obj)

        if(param === 'batal'){
            // console.log(param)
            this.props.handleClose(param, obj)
            // this.setState({ openAdd: false });
            this.setState(initialState)
        } else if (param === 'tambah') {
            // console.log(param)
            const result = await this.handleAddUser(obj)
            // console.log(result)
            if(result.data.status === true){
                this.props.handleClose(param, obj)
                NotificationManager.success('Add User Success', 'Success message')
                this.setState(initialState)
            } else {
                NotificationManager.error(result.data.message, 'error message')
            }
        }
    }

    render() {
        const {classes} = this.props
        const filter = [
            {
                name:"role_parent",
                "logic_operator":"=",
                value: rolename.toString(),
                "operator":"AND"
            }
        ]
        return (
            <div>
                <Dialog
                    fullScreen
                    open={this.props.openAdd}
                    onClose={() => this.props.handleClose('batal')}
                    TransitionComponent={Transition}
                    >
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                        {/* <IconButton color="inherit" onClick={() => this.handleClose('')} aria-label="Close">
                            <CloseIcon />
                        </IconButton> */}
                        <Typography variant="h6" color="inherit" className={classes.flex}>
                           Pengguna
                        </Typography>
                        <Button variant="contained" className="bg-white text-black" onClick={() => this.props.handleClose('batal')}>
                            cancel
                        </Button>&nbsp;&nbsp;
                        <Button variant="contained" color="primary" onClick={() => this.handleSave('tambah')}>
                            save
                        </Button>
                        </Toolbar>
                    </AppBar>
                    
                    <div className="app-wrapper">
                        <Grid container spacing={24}>
                            <Grid item xs={6}>
                                <TextField
            
                                    id="fullname"
                                    label="Nama Lengkap"
                                    type="text"
                                    value={this.state.fullname}
                                    onChange={(e) => this.setState({fullname: e.target.value})}
                                    fullWidth
                                />
                                <TextField
                                    value={this.state.username}
                                    id="username"
                                    label="Username"
                                    type="text"
                                    onChange={(e) => this.setState({username: e.target.value})}
                                    fullWidth
                                />
                                <TextField
                                    value={this.state.password}
                                    id="password"
                                    label="Password"
                                    type="password"
                                    onChange={(e) => this.setState({password: e.target.value})}
                                    fullWidth
                                />
                                <TextField
                                    value={this.state.email}
                                    id="email"
                                    label="Email"
                                    type="email"
                                    onChange={(e) => this.setState({email: e.target.value})}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={6}>
                            
                            <InputVirtual 
                                label="Perusahaan"
                                value=""
                                name="name"
                                lengthData={20}
                                url={BASE_URL_APIv5+"/company/search"}
                                getData={this.getInputCompany}
                                setData={[{name:"id",value:this.state.company.toString(),"logic_operator":"=","operator":"AND"}]}
                                fullWidth={true}
                                dialogForm="DialogFormCompany"
                            />

                            <InputVirtual 
                                label="Role"
                                value=""
                                name="role_name"
                                lengthData={20}
                                filter={[{name:"role_parent","logic_operator":"=",value:rolename,"operator":"OR"},
                                {name:"role_name","logic_operator":"=",value:rolename,"operator":"OR"}]}
                                url={BASE_URL_APIv5+"/master-role/search"}
                                getData={this.getInputRoleName}
                                // setData={[{name:"id",value:this.state.company.toString(),"logic_operator":"=","operator":"AND"}]}
                                fullWidth={true}
                            />

                            </Grid>
                        </Grid>
                    </div>
                    </Dialog>
                    
            </div>
        );
    }
}

export default withStyles(styles)(DialogUser);


// WEBPACK FOOTER //
// ./app/routes/MasterUser/DialogUser.js